/**
 * PageNotFoundComponent
 * ---------------------
 * Ova komponenta se prikazuje kada korisnik pokuša pristupiti nepostojećoj stranici.
 * Sadrži gumb za povratak na početnu stranicu.
 */
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  imports: [],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.css'
})
export class PageNotFoundComponent {
  private router = inject(Router);

  navigateToHome() {
    this.router.navigate(['/home']);
  }
}
